import React from "react";
var UserCountryContext = /*#__PURE__*/ React.createContext({});
export default UserCountryContext;
